import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import logo_livetracking from '../icons/logo_akma_livetracking.png'
import logo_livetracking_a from '../icons/logo_akma_livetracking_a.png'
import LogoutButton from '../Components/LogoutButton'

import {DashboardContext} from '../Context/DashboardContext'
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';




function Header() {

	const navigate = useNavigate()
	const isLargeScreen = useMediaQuery('(min-width:600px)');
	const dbContext = React.useContext(DashboardContext)

	return(
		<Box sx={{ flexGrow: 1 }}>
			{isLargeScreen ?
			<AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, bgcolor : "#3490dc" }}>
				<Toolbar>
					<Box
						component="img"
						src={logo_livetracking}
						height={35}
						style={{cursor : "pointer"}}
						onClick= {() => {navigate("/dashboard")}}
					>
					</Box>
					<Typography  variant="h5" sx={{ flexGrow: 1,display : "flex",alignItems : "center", justifyContent : "center" }}>{dbContext.user.name}</Typography>
					<LogoutButton></LogoutButton>
				</Toolbar>
			</AppBar>
			:
			<AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, bgcolor : "#3490dc" }}>
				<Box display={"flex"} height={58} alignItems={"center"} justifyContent={"center"} >
					<Box sx={{ width : "15%", display : "flex",alignItems : "center", justifyContent : "start",pl : 1 }}>
						<Box
							component="img"
							src={logo_livetracking_a}
							height={30}
							style={{cursor : "pointer"}}
							onClick= {() => {navigate("/dashboard")}}
						>
						</Box>
					</Box>
					<Box sx={{ width : "70%", display : "flex",alignItems : "center", justifyContent : "center" }}>
						<Typography  variant="subtitle1" sx={{ flexGrow: 1,display : "flex",alignItems : "center", justifyContent : "center" }}>{dbContext.user.name}</Typography>
					</Box>
					<Box sx={{ width : "15%", display : "flex",alignItems : "center", justifyContent : "end" }}>
						<LogoutButton isLargeScreen={isLargeScreen}></LogoutButton>
					</Box>
				</Box>
			</AppBar>
			}
    	</Box>
	)
}

export default Header